import { html, LitElement, type TemplateResult } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("colour-label")
export class ColourLabel extends LitElement {
    connectedCallback(): void {
        super.connectedCallback();

        const colorFieldset = document.querySelector(
            'variant-radios [data-type="Colour"]',
        );
        colorFieldset?.addEventListener("change", () => {
            this.currentVariant = this.getVariant();
        });
    }

    @property({ type: String, reflect: true })
    protected currentVariant: string = this.getVariant();

    getVariant(): string {
        const colorSelector = document.querySelector(
            'variant-radios [data-type="Colour"]',
        );
        const colorToUse: string = colorSelector
            .querySelector(".product-form__input input[type=radio]:checked")
            .getAttribute("value");
        return colorToUse;
    }

    render(): TemplateResult {
        return html`
      <span>${this.currentVariant}</span>
    `;
    }
}
